import React, { forwardRef, useCallback, useMemo } from 'react';
import { withStyles, Theme, MenuItem, ListItemText } from '@material-ui/core';
import { GameTypeOptionProps, GameTypeOptionsProps } from 'components/SelectOptions/type';
import CodeVO from 'commons/vo/CodeVO';

export const StyledMenuItem = withStyles((theme: Theme) => ({
  root: {
    '&.Mui-selected': {
      backgroundColor: '#D94F98',
      borderBottom: '1px solid #ffffff',
      color: '#ffffff',
      // '& > *': {
      // color: '#ffffff',
      // },
      '&:hover': {
        backgroundColor: '#D94F98',
      },
    },
    '&:focus': {
      // backgroundColor: '#D94F98',
      // borderBottom: '1px solid #ffffff',
      // '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
      //   color: theme.palette.common.white,
      // },
    },
  },
}))(MenuItem);

function Option({ gameType, selectedGameTypes, onClick }: GameTypeOptionProps) {
  const isActive = useMemo(() => {
    const index = selectedGameTypes.findIndex(selectedGameType => gameType.id === selectedGameType);
    return index !== -1;
  }, [selectedGameTypes, gameType]);

  const onClickItem = useCallback(() => {
    onClick(gameType.id);
  }, [onClick, gameType.id]);
  return (
    <StyledMenuItem onClick={onClickItem} selected={isActive}>
      <ListItemText>{gameType.name}</ListItemText>
    </StyledMenuItem>
  );
}

function GameTypeOptions({ gameTypes, selectedGameTypes, onClickGameType }: GameTypeOptionsProps) {
  return (
    <>
      {gameTypes.map((gameType: CodeVO) => (
        <Option
          key={gameType.id}
          gameType={gameType}
          selectedGameTypes={selectedGameTypes}
          onClick={onClickGameType}
        />
      ))}
    </>
  );
}

export default GameTypeOptions;
